import React from 'react'

import { Icon } from '@mxenabled/mx-icons'

import DialogTitle from '@mui/material/DialogTitle'
import IconButton from '@mui/material/IconButton'

export interface FeedbackHeaderObjProps {
  headerText: string
  menuHeaderCloseButtonAriaLabel: {
    ratingExist?: string
    ratingDoesntExist?: string
  }
  rating?: number
  sx?: React.CSSProperties
}

export interface FeedbackHeaderProps extends FeedbackHeaderObjProps {
  onCancel: () => void
  onClose: () => void
}

export const FeedbackHeader: React.FC<FeedbackHeaderProps> = ({
  headerText,
  menuHeaderCloseButtonAriaLabel,
  onCancel,
  onClose,
  rating,
  sx = {},
}) => {
  return (
    <DialogTitle fontSize={18} id="alert-dialog-title">
      {headerText}
      <IconButton
        aria-label={
          rating
            ? menuHeaderCloseButtonAriaLabel.ratingExist
            : menuHeaderCloseButtonAriaLabel.ratingDoesntExist
        }
        data-ui-test="feedback-close-button"
        onClick={() => {
          onCancel()
          onClose()
        }}
        sx={{
          position: 'absolute',
          right: 12,
        }}
      >
        <Icon
          name="cancel"
          sx={{
            ...sx,
          }}
        />
      </IconButton>
    </DialogTitle>
  )
}
